import React, { useContext, useEffect, useState } from "react";
import { Button, CircularProgress, Tab, Tabs, Typography } from "@material-ui/core";
import { AttachFile, CodeOutlined, HttpsOutlined, LinkOutlined, PhoneAndroidOutlined, SettingsEthernet, TextsmsOutlined } from "@material-ui/icons";
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";
import CrmTheme from "../CrmRelationship/theme";
import CControle from "./CControle";
import { getEndpoint } from "./helpers";
import Reference, { CopyButton } from "./Reference";
import SendForm from "./SendForm";
import useStyles from "./styles";

export function MessagesAPIContent() {
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const [access, setAccess] = useState("loading");
  const [retry, setRetry] = useState(0);
  const [tab, setTab] = useState(0);
  const [busy, setBusy] = useState(false);
  const endpoint = getEndpoint();
  const companyId = user && user.companyId;
  useEffect(() => {
    let active = true;
    setAccess("loading");
    if (!companyId) return () => { active = false; };
    api.get(`/companies/listPlan/${companyId}`).then(({ data }) => {
      if (active) setAccess(data.plan && data.plan.useExternalApi ? "allowed" : "denied");
    }).catch(() => { if (active) setAccess("error"); });
    return () => { active = false; };
  }, [companyId, retry]);
  return <div className={classes.root}>
    <header className={classes.header}>
      <div className={classes.headerIcon}><CodeOutlined /></div>
      <div><Typography component="h1" className={classes.title}>API de mensagens</Typography><Typography className={classes.muted}>Conecte outros sistemas ao WhatsApp do CChat.</Typography></div>
    </header>
    {access !== "allowed" ? <div className={`${classes.card} ${classes.status}`} role="status">
      {access === "loading" ? <><CircularProgress size={28} /><Typography>Verificando acesso à API…</Typography></> : access === "error" ? <><Typography>Não foi possível verificar o acesso à API.</Typography><Button variant="outlined" color="primary" onClick={() => setRetry(value => value + 1)}>Tentar novamente</Button></> : <Typography>A API externa não está habilitada no plano desta empresa.</Typography>}
    </div> : <>
      <div className={classes.prerequisites} aria-label="Antes de começar">
        <div className={classes.prerequisite}><HttpsOutlined /><div><Typography className={classes.stepTitle}>Token da conexão</Typography><Typography className={classes.muted}>Copie em Conexões → Editar → Token.</Typography></div></div>
        <div className={classes.prerequisite}><PhoneAndroidOutlined /><div><Typography className={classes.stepTitle}>WhatsApp conectado</Typography><Typography className={classes.muted}>O token identifica a conexão que fará o envio.</Typography></div></div>
        <div className={classes.prerequisite}><SettingsEthernet /><div><Typography className={classes.stepTitle}>Número completo</Typography><Typography className={classes.muted}>Informe DDI + DDD + número, somente dígitos.</Typography></div></div>
      </div>
      <Tabs value={tab} onChange={(_, value) => setTab(value)} indicatorColor="primary" textColor="primary" variant="scrollable" scrollButtons="auto" className={classes.tabs} aria-label="Tipo de integração">
        <Tab classes={{ root: classes.tab, wrapper: classes.tabWrapper }} id="api-tab-text" aria-controls="api-panel-text" label="Texto" icon={<TextsmsOutlined />} disabled={busy} />
        <Tab classes={{ root: classes.tab, wrapper: classes.tabWrapper }} id="api-tab-media" aria-controls="api-panel-media" label="Arquivo" icon={<AttachFile />} disabled={busy} />
        <Tab classes={{ root: classes.tab, wrapper: classes.tabWrapper }} id="api-tab-ccontrole" aria-controls="api-panel-ccontrole" label="Integração CControle" icon={<LinkOutlined />} disabled={busy} />
      </Tabs>
      {tab < 2 && <div className={classes.endpoint}><span className={classes.method}>POST</span><code>{endpoint}</code><CopyButton text={endpoint} label="Copiar endereço da API" /></div>}
      {["text", "media"].map((mode, index) => <div key={mode} role="tabpanel" id={`api-panel-${mode}`} aria-labelledby={`api-tab-${mode}`} hidden={tab !== index}>
        <div className={classes.columns}><Reference mode={mode} endpoint={endpoint} /><SendForm mode={mode} endpoint={endpoint} onBusyChange={setBusy} /></div>
      </div>)}
      <div role="tabpanel" id="api-panel-ccontrole" aria-labelledby="api-tab-ccontrole" hidden={tab !== 2}><CControle /></div>
    </>}
  </div>;
}

export default function MessagesAPI() { return <CrmTheme><MessagesAPIContent /></CrmTheme>; }
